import $ from "jquery"
var emagazine = {
    init : function () {
        this.photoFullWidth()
        $(window).resize(function () {
            emagazine.photoFullWidth()
        })

    },
    photoFullWidth : function () {
        let widthBody = parseInt($('body').css('width'));
        let widthContentBlock = parseInt($('.content-other-blocks').css('width'));
        let paddingTwoSideContentBlock = parseInt($('.content-other-blocks').css('padding-left').slice(0,-2));
        let marginLeftOfAlignJustifyFull = (widthBody - widthContentBlock)/2 + paddingTwoSideContentBlock
        $('.content-other-blocks .alignJustifyFull').css('margin-left', '-' + marginLeftOfAlignJustifyFull +'px')
    }
}

$(document).ready(function () {
    emagazine.init()
})
